import { Injectable } from '@angular/core';
import moment from 'moment';
import { TimeDateValidator } from './time-date-validator.service';

@Injectable({
  providedIn: 'root'
})

export class TimeValidator extends TimeDateValidator {

  getTimeDateStamp(formData) {
    const minValue = moment('09:59', 'hh:mm');
    const maxValue = moment('18:01', 'hh:mm');
    const { hour, minute } = formData;

    const timeStamp = moment(`${hour}:${minute}`, 'hh:mm');

    return timeStamp.isBetween(minValue, maxValue);
  }

  // validateTimeDate() is invoked from base class
}
